import { render, staticRenderFns } from "./AwaitingPostingData.vue?vue&type=template&id=1be195e8"
import script from "./AwaitingPostingData.vue?vue&type=script&lang=js"
export * from "./AwaitingPostingData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports